import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../routing/getFlowKey';
import { BranchCmsBusinessMaturity } from './branches/BranchCmsBusinessMaturity';
import { BranchIntegratedAppCookieless } from './branches/BranchIntegratedAppCookieless';
import { BranchOptionalPhoneNumber } from './branches/BranchOptionalPhoneNumber';
import { BranchQuestionFallback } from './branches/BranchQuestionFallback';
import { ProductSetupUIBranch } from './branches/ProductSetupUIBranch';
import { BranchAddHubletExistingUser } from './branches/BranchAddHubletStep';
import { BranchAddHubletNewUser } from './branches/BranchAddHubletNewUser';
import { BranchAeoCreateBrandPurchase } from './branches/BranchAeoCreateBrandPurchase';
import { BranchACQ0177VariantA } from './branches/BranchACQ0177VariantA';
import { BranchSU0004 } from './branches/BranchSU0004';
let FlowBranches;

// DefaultBranches is initialized inside getFlowBranches() to defer the reference
// to BranchQuestionFallback until after module initialization, breaking the
// problematic import cycle through getStepConfig -> StepViews -> decideBranch
let DefaultBranches;
export const getFlowBranches = () => {
  if (typeof FlowBranches === 'undefined') {
    DefaultBranches = [BranchQuestionFallback];
    const softwareSignupBranches = [...DefaultBranches, BranchOptionalPhoneNumber, BranchAddHubletExistingUser, BranchAddHubletNewUser];
    FlowBranches = {
      [Flow.Crm]: [...softwareSignupBranches, BranchACQ0177VariantA, BranchSU0004],
      [Flow.Marketing]: [...softwareSignupBranches, BranchACQ0177VariantA, BranchSU0004],
      [Flow.Sales]: [...softwareSignupBranches, BranchSU0004, ProductSetupUIBranch, BranchACQ0177VariantA],
      [Flow.Service]: [...softwareSignupBranches, BranchACQ0177VariantA, BranchSU0004],
      [Flow.CmsFree]: [BranchCmsBusinessMaturity, ...softwareSignupBranches],
      [Flow.Integrations]: [BranchIntegratedAppCookieless, BranchAddHubletExistingUser, BranchAddHubletNewUser],
      [Flow.ClassroomTraining]: [BranchAddHubletExistingUser, BranchAddHubletNewUser],
      [Flow.AssetProvider]: [BranchAddHubletExistingUser, BranchAddHubletNewUser],
      [Flow.FbCrm]: [BranchAddHubletExistingUser, BranchAddHubletNewUser],
      [Flow.HubspotForStartups]: [BranchAddHubletExistingUser, BranchAddHubletNewUser],
      [Flow.HubSpotPartners]: [BranchAddHubletExistingUser, BranchAddHubletNewUser],
      [Flow.Microapp]: [BranchCmsBusinessMaturity, BranchAddHubletExistingUser, BranchAddHubletNewUser],
      [Flow.Commerce]: [BranchAddHubletExistingUser, BranchAddHubletNewUser, BranchSU0004],
      [Flow.Academy]: [BranchAddHubletExistingUser, BranchAddHubletNewUser],
      [Flow.AcademyEmbedded]: [BranchAddHubletExistingUser, BranchAddHubletNewUser],
      [Flow.DirectoryListing]: [BranchAddHubletExistingUser, BranchAddHubletNewUser],
      [Flow.CmsDevelopers]: [BranchAddHubletExistingUser, BranchAddHubletNewUser],
      [Flow.Trial]: [BranchAddHubletExistingUser, BranchAddHubletNewUser],
      [Flow.Purchase]: [BranchAddHubletExistingUser, BranchAddHubletNewUser, BranchACQ0177VariantA],
      [Flow.AeoStandalone]: [BranchAeoCreateBrandPurchase, BranchAddHubletExistingUser, BranchAddHubletNewUser]
    };
  }
  return FlowBranches[getFlowKey()] || DefaultBranches;
};